import { useRouter, type Href } from 'expo-router';
import { useCallback } from 'react';

/**
 * Back handler that survives web reloads: pop in-app history when present,
 * otherwise navigate to a sensible parent (`fallback`). Mirrors the guard in
 * paywall.tsx so every header back button behaves the same.
 *
 * On web a full page reload resets expo-router's in-memory history to a single
 * entry, so a bare `router.back()` throws "GO_BACK was not handled by any
 * navigator". `canGoBack()` guards against that.
 */
export function useGoBack(fallback: Href) {
  const router = useRouter();
  return useCallback(() => {
    if (router.canGoBack()) router.back();
    else router.replace(fallback);
  }, [router, fallback]);
}
